










































import { helpers, required, requiredIf, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';

export default {
	name: 'MakeOfferTotalSalary',

	setup() {
		const form = reactive({
			total_salary: 20000,
		});

		const errors = ref<object>(null);

		const numeric = helpers.regex(/^[0-9]*$/);

		const rules = computed(() => ({
			total_salary: {
				required: helpers.withMessage('Total Salary is required.', required),
				numeric: helpers.withMessage('Total Salary can only be numbers.', numeric),
				minValue: helpers.withMessage('Amount must be greater than 0', function (value) {
					return value > 0;
				}),
			},
		}));

		const data = useVuelidate(rules, form);

		const edit = ref(false);

		const loading = ref(false);

		return { form, edit, loading, data, errors };
	},
	computed: {
		...mapGetters('jobs/single', {
			job: 'getSingleJob',
		}),

		...mapGetters('offerModule', {
			salary: 'getSalary',
		}),

		jobSalary() {
			return JSON.parse(JSON.stringify(this.salary));
		},
	},

	mounted() {
		this.populateData();
	},

	methods: {
		submit() {
			if (this.edit) {
				this.toggleEdit();
				this.updateJobSalary();
			} else {
				this.updateJobSalary();
				this.$store.dispatch('offerModule/setCurrentStep', 4);
			}
		},
		toggleEdit() {
			this.edit = !this.edit;
		},

		cancel() {
			if (this.edit) {
				this.populateData();
				this.toggleEdit();
			} else {
				this.$emit('close');
			}
		},
		populateData() {
			this.form.total_salary = this.jobSalary ? this.jobSalary : 20000;
			this.updateJobSalary();
		},

		updateJobSalary() {
			this.$store.dispatch('offerModule/updateSalary', this.form.total_salary);
		},
	},
};
